var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "106px",
    height: "106px",
    viewBox: "0 0 106 106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC68\\u200D\\u2695\\uFE0F-Primary-Care-Dentist",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error",
    transform: "translate(-767.000000, -173.000000)",
    fill: "#ED6300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(199.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(251.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic/Failure-large",
    transform: "translate(317.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.643,59.06 L57.187,59.06 L57.187,22.19 L48.643,22.19 L48.643,59.06 Z M48.643,83.64 L57.187,83.64 L57.187,71.35 L48.643,71.35 L48.643,83.64 Z",
    id: "Fill-1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,53 C101,26.490684 79.5096774,5 53.0005056,5 C26.4911113,5 5,26.4909063 5,53 C5,79.5090937 26.4911113,101 53.0005056,101 C79.5096774,101 101,79.509316 101,53 Z M106,53 C106,82.2705281 82.2713129,106 53.0005056,106 C23.7296983,106 0,82.2705281 0,53 C0,23.7294719 23.7296983,0 53.0005056,0 C82.2713129,0 106,23.7294719 106,53 Z",
    id: "Stroke-1",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnable);
export default __webpack_public_path__ + "static/media/unable.29e46b777b5d108267089152a15f5c50.svg";
export { ForwardRef as ReactComponent };